import { ApiError } from 'src/error/customError/ApiError';
export class UnauthorizedError extends ApiError {}
